// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { SiteV3ClientGeneratedSiteLicenseType } from './siteV3ClientGeneratedSiteLicenseType.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class SiteV3ClientGeneratedSiteLicenseUpsearchModel {
    'siteLicenseId'?: number | null;
    'licenseType'?: SiteV3ClientGeneratedSiteLicenseType;
    'licenseNumber': string;
    'licenseStateCd': string;
    'licenseExpirationDt'?: Moment | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof SiteV3ClientGeneratedSiteLicenseUpsearchModel>> = [
        {
            "name":     "siteLicenseId",
            "baseName": "siteLicenseId",
            "type":     "number"
        },
        {
            "name":     "licenseType",
            "baseName": "licenseType",
            "type":     "SiteV3ClientGeneratedSiteLicenseType"
        },
        {
            "name":     "licenseNumber",
            "baseName": "licenseNumber",
            "type":     "string"
        },
        {
            "name":     "licenseStateCd",
            "baseName": "licenseStateCd",
            "type":     "string"
        },
        {
            "name":     "licenseExpirationDt",
            "baseName": "licenseExpirationDt",
            "type":     "Date"
        },
    ];

    static getAttributeTypeMap() {
        return SiteV3ClientGeneratedSiteLicenseUpsearchModel.attributeTypeMap;
    }
}
